import React, { useState } from "react"
import { get } from "lodash"
import {
  Box,
  Stack,
  Button,
  IconButton,
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
} from "@mui/material"
import { css, Global } from "@emotion/react"
import { makeStyles } from "@material-ui/core"
import CloseIcon from "@mui/icons-material/Close"

import { showSuccess, showError } from "../v2_actions/error"
import { PhotographUploader } from "./form/PhotographUploader"
import { useDispatch } from "react-redux"
import { fileInfoList } from "v2_actions/file_info"
import LoadingSpinner from "../components/LoadingSpinner"

const useStyles = makeStyles((theme) => ({
  alertDialogHeading: {
    color: "#000",
    fontWeight: 800,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {},
  },
}))

const global_styles = css`
  h2.MuiDialogTitle-root {
    font-size: 16px
    font-weight: 800
  }
  div.MuiDialog-paperScrollPaper {
    width: 800px
    border-radius: 15px
    border: solid #000 1px
  }
`

export const AddGalleryEventLogoDialog = ({ handleClose, setCustomGalleryEventLogo }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [
    isUploadingCustomGalleryEventLogo,
    setIsUploadingCustomGalleryEventLogo,
  ] = useState(false)

  const handleUploadCustomGalleryEventLogo = (files) => {
    setIsUploadingCustomGalleryEventLogo(true)
    dispatch(fileInfoList.upload(files[0]))
      .then((file_info) => {
        setCustomGalleryEventLogo(
          "custom_gallery_event_logo",
          get(file_info, "id"),
          { shouldValidate: true }
        )
      })
      .catch((error) => {
        showError("Error", "File upload failed")
        console.error(error)
      })
      .finally(() => setIsUploadingCustomGalleryEventLogo(false))
  }

  const handleRemoveCustomGalleryEventLogo = () => {
    setCustomGalleryEventLogo("custom_gallery_event_logo", null, {
      shouldValidate: true,
    })
    handleClose()
  }

  const renderPhotoUploader = () => {
    return (
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-evenly"
      >
        <PhotographUploader
          isEditorForLogoUpload={true}
          uploadMessage='Drag and Drop or Click to add Logo'
          onChange={({ files }) => handleUploadCustomGalleryEventLogo(files)}
        />
      </Stack>
    )
  }

  return (
    <div>
      <Global styles={global_styles} />
      <Dialog
        open
        mb={2}
        keepMounted
        disablePortal={true}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.alertDialogHeading}>
          <Typography mt={3} variant="b" component="p">
            Upload Logos
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              top: 8,
              right: 8,
              position: "absolute",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {isUploadingCustomGalleryEventLogo && <LoadingSpinner />}
        <DialogContent>
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Box>{renderPhotoUploader()}</Box>
            <Box>Or</Box>
            <Box>
              <Button
                variant="contained"
                onClick={handleRemoveCustomGalleryEventLogo}
              >
                <b>Use Event Logo</b>
              </Button>
            </Box>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  )
}
